import React from "react";
import { Switch as RNSwitch } from "react-native";
const Switch = ({ ...rest }) => {
    return <RNSwitch {...rest}/>;
};
export default Switch;
